// extracted by mini-css-extract-plugin
export var root = "styles-module--root--2u2nm";
export var header = "styles-module--header--1IpFJ";